/**
 * Loads the Vazirmatn Persian webfont before Pixi boots, so canvas text shapes Persian correctly.
 * Best-effort: if the CDN is unreachable (e.g. blocked), we fall back to Tahoma/system fonts, which
 * still render Persian acceptably. Never blocks boot for more than a couple of seconds.
 */
const CDN = 'https://cdn.jsdelivr.net/npm/vazirmatn@33.0.3/fonts/webfonts';

async function withTimeout<T>(p: Promise<T>, ms: number): Promise<T> {
  return Promise.race([
    p,
    new Promise<T>((_, reject) => setTimeout(() => reject(new Error('font load timeout')), ms)),
  ]);
}

export async function loadFonts(): Promise<void> {
  if (typeof document === 'undefined' || !('fonts' in document)) return;
  try {
    const faces = [
      new FontFace('Vazirmatn', `url(${CDN}/Vazirmatn-Regular.woff2)`, { weight: '400' }),
      new FontFace('Vazirmatn', `url(${CDN}/Vazirmatn-Bold.woff2)`, { weight: '700' }),
    ];
    const loaded = await withTimeout(Promise.all(faces.map((f) => f.load())), 2500);
    for (const f of loaded) document.fonts.add(f);
  } catch {
    // Fall back to system fonts — Persian still renders via Tahoma/system-ui.
  }
}
